module.exports = __webpack_public_path__ + "static/media/noclass6.4cb7af15.png";